import Vue from 'vue';
import Appsignal from '@appsignal/javascript';

import { plugin as consolePlugin } from '@appsignal/plugin-breadcrumbs-console';
import { plugin as networkPlugin } from '@appsignal/plugin-breadcrumbs-network';
import { plugin as windowPlugin } from '@appsignal/plugin-window-events';
import { plugin as pathPlugin } from '@appsignal/plugin-path-decorator';
import { errorHandler } from '@appsignal/vue';

const appsignal = new Appsignal({"active":true,"name":"@scenkonst/uso-frontend","revision":"3.0.0-uso.r20250116.0-a9d0d06","environment":"production","key":"58a05b98-6713-47da-b2b4-71795fe6f5d9"});

appsignal.use(consolePlugin({}));
appsignal.use(networkPlugin({}));
appsignal.use(windowPlugin({}));
appsignal.use(pathPlugin({}));

Vue.config.errorHandler = errorHandler(appsignal, Vue);

/** @type {import('@nuxt/types').Plugin} */
export default (context, inject) => {
  inject('appsignal', appsignal);
  context.$appsignal = appsignal;
}
